// Utility functions for formatting patient information in the ConfirmEditModal

// Determines the color based on whether a value is present
export const getStatusColour = (hasValue) =>
  hasValue ? "primary.main" : "text.secondary";

// Maps language codes to their display labels
export const getLangLabel = (code, t) =>
  ({ en: t("languages.english"), fr: t("languages.french") })[code] || code;

// Builds a display string and color for a set of values, using a separator
const buildJoinedText = (values, notProvided, separator = ", ") => {
  const parts = values.filter(Boolean);

  return {
    text: parts.length ? parts.join(separator) : notProvided,
    colour: getStatusColour(parts.length),
  };
};

// Builds a display string and color for a set of labeled values
const buildLabeledText = (items, notProvided) => {
  const hasAnyValue = items.some((item) => item.value);

  return {
    text: items
      .map((item) => `${item.label}: ${item.value || notProvided}`)
      .join("\n"),
    colour: getStatusColour(hasAnyValue),
  };
};

export const getAddressInfo = (patientValues, notProvided) =>
  buildJoinedText(
    [
      patientValues.address,
      patientValues.city,
      patientValues.postalCode,
      patientValues.province,
    ],
    notProvided
  );

export const getHealthCardInfo = (patientValues, t, notProvided) =>
  buildLabeledText(
    [
      {
        label: t("confirmEditModal.healthCard.number"),
        value: patientValues.healthCardNumber,
      },
      ...(patientValues.healthCardProvince === "MB"
        ? [
            {
              label: t("confirmEditModal.healthCard.registration"),
              value: patientValues.registrationNumber,
            },
          ]
        : []),
      {
        label: t("confirmEditModal.healthCard.province"),
        value: patientValues.healthCardProvince,
      },
    ],
    notProvided
  );

export const getPhoneInfo = (patientValues, t, notProvided) =>
  buildLabeledText(
    [
      {
        label: t("confirmEditModal.phone.primary"),
        value: patientValues.primaryPhone,
      },
      {
        label: t("confirmEditModal.phone.secondary"),
        value: patientValues.secondaryPhone,
      },
    ],
    notProvided
  );
